import { Table } from 'semantic-ui-react';
import React from 'react';

export default {
    demo: {
        todayIs: 'Today is'
    },
    errors: {
        showAllErrors: 'Show All Errors ({count})',
        hideErrors: 'Hide Errors',
    },
    common: {
        clear: 'Clear',
        bhs: 'B/H/S language',
        eng: 'English language',
        group: 'Group',
        totalEcts: 'Total ECTS:',
        socialStatus: 'Social status',
        academicStaff: 'Academic staff',
        notFound: 'Page not found',
        courseRoleType: 'Role',
        courseDetails: 'Course details',
        details: 'Details',
        ordinal: 'Ord.',
        comment_: 'Note',
        logout: 'Logout',
        editAdd: 'Add / edit',
        add: 'Add',
        send: 'Send',
        cancel: 'Cancel',
        cancelO: 'Cancel',
        ok: 'Confirm',
        firstName: 'Firstname',
        lastName: 'Lastname',
        lastNameAndFirstName: 'Lastname and firstname',
        studentLastNameAndFirstName: 'Student lastname and firstname',
        dateOfAbandonment: 'Date of abandonment',
        maidenName: 'Maiden name',
        student: 'Student',
        index: 'Index',
        degree: 'Degree number',
        edit: 'Edit',
        save: 'Save',
        delete: 'Delete',
        language: 'Language',
        comment: 'Comment',
        titleGender: 'Gender for titles',
        debit: 'Debit',
        date: 'Date',
        courseName: 'Course name',
        back: 'Back',
        confirm: 'Confirm',
        show: 'Show',
        grade: 'Grade',
        teacher: 'Teacher',
        semester: 'Semester',
        course: 'Course',
        courses: 'Courses',
        faculty: 'Faculty',
        faculties: 'Faculties',
        academicYear: 'Academic year',
        municipality: 'Municipality',
        unsa: 'University of Sarajevo',
        studyCycle: 'Study cycle',
        citizenship: 'Citizenship',
        process: 'Processsing...',
        successfully: 'Successfully...',
        studentsList: 'Students',
        graduatedDate: 'Date of graduation',
        yes: 'YES',
        no: 'NO',
        areYouSure: 'Are you sure?',
        info: 'Informations',
        userManualInfoTooltip: 'By clicking the same icon in the upper-right corner of the page, you can see more details about this part of the system in the user manual.',
        userManualInfoTooltipPrefix: 'By clicking the icon',
        userManualInfoTooltipSuffix: 'in the upper-right corner of the page, you can see more details about this part of the system in the user manual.',
        error: 'Error!',
        oneExamRestrictionError: 'You can register only one exam for this exam term!',
        lecture: 'Lecture (hours)',
        exercise: 'Exercise (hours)',
        lectureExerciseSeminar: 'L + E + S',
        lectureExerciseSeminarAbr: 'L + E + S',
        select: 'Select',
        chose: 'Select',
        average: 'Average',
        gradeAverage: 'Average grade: ',
        studyProgram: 'Study program',
        studyType: 'Study type',
        contact: 'Contact',
        department: 'Department',
        jmbg: 'JMBG',
        username: 'Username',
        accountMail: 'Account e-mail',
        dateOfBirth: 'Date of birth',
        gender: 'Gender',
        father: 'Father\'s firstname and lastname',
        mother: 'Mother\'s firstname and lastname',
        fatherName: 'Father\'s firstname',
        motherName: 'Mother\'s lastname',
        placeOfBirth: 'Place of birth',
        residence: 'Residence',
        currentResidence: 'Current residence',
        nationality: 'Nationality',
        classroom: 'Classroom',
        noResultMessage: 'No results found!',
        description: 'Description / note',
        phone: 'Phone',
        mail: 'E-mail',
        studyAddress: 'Current adress',
        cantonResidence: 'Canton of residence',
        municipalityResidence: 'Municipality of residence',
        addressResidence: 'Address of residence',
        archive: 'Archive',
        courseCode: 'Course code',
        code: 'code',
        startPage: ' ',
        editOrAdd: 'Add / edit',
        coursesList: 'Courses',
        leadStaff: 'Lead staff',
        filterRequired: 'You must enter what you want to filter!',
        studyProgramName: 'Study program name',
        selectStudyProgram: 'Select study program',
        inputIndex: 'Enter index number',
        inputName: 'Enter firstname',
        inputLastName: 'Enter lastname',
        personalInfo: 'Personal info',
        students: 'Students',
        courseType: 'Course type',
        mandatory: 'Mandatory',
        optional: 'Optional',
        notice: 'Notice',
        notification: 'Notification',
        notifications: 'Notifications',
        allNotificationsTitle: 'All notifications',
        viewAllNotifications: 'All notifications',
        newNotificationsMore: 'new notifications – view all',
        filterUnread: 'Unread only',
        filterAll: 'All',
        loadMore: 'Load next {count}',
        selectAllToSeeRead: 'Select the "All" option to see all previously read notifications.',
        markAllAsReadHint: 'Marks all unread notifications as read. They stay visible but are no longer shown as new.',
        inputNotification: 'Enter notification text..',
        newNotifications: 'New notifications',
        newNotification: 'New notification',
        markAllAsRead: 'Mark all as read',
        new: 'NEW',
        activeNotifications: 'Active notifications',
        previousNotifications: 'Previouse notifications',
        noNewNotifications: 'You don\'t have new notifications.',
        notificationsUnavailable: 'Notifications are temporarily unavailable.',
        noActiveNotifications: 'You don\'t have active notifications.',
        noPreviousNotifications: 'You don\'t have previous notifications.',
        systemUserGuide: 'View the user guide',
        title: 'Notification title',
        notificationType: 'Notification type',
        notificationStartDate: 'Publication date',
        notificationEndDate: 'Expiration date',
        recipientsProfessors: 'Recipients (Professors)',
        recipientsEmployees: 'Recipients (Employee)',
        recipientsStudents: 'Recipients (Students)',
        requiredFields: 'You must fill all required fields.',
        requiredEmailForm: 'Enter valid email.',
        notificationSent: 'Notification was successfully sent.',
        notificationSentError: 'Failed to add new notification.',
        employees: 'Employees',
        professors: 'Professors',
        image: 'Student image',
        semesterName: 'Semester name',
        semesterNumber: 'Semester number',
        applicationDate: 'Application date',
        english: 'English',
        bosnian: 'B / C / S',
        startEngagement: 'Start of employment',
        endEngagement: 'End of employment',
        titleElection: 'Election to the title',
        academicTitle: 'Title',
        titleExpiration: 'Expiration of the title',
        noEmploymentInfo: 'No information about the title of employee. Contact your HR administrator.',
        noPositionInfo: 'No information about the positions of employee. Contact your HR administrator.',
        filterStudents: 'Search',
        noData: 'No data...',
        noDataToDisplay: 'No data to display.',
        enrolmentCountInSemester: 'Enrolment count in semester',
        droppedOut: 'Dropped out student',
        locked: 'Locked student',
        oid: 'OID',
        section: 'Section',
        intervalStart: 'From',
        intervalEnd: 'To',
        ects: 'ECTS',
        noNotificationText: 'No text.',
        assistants: 'Assistants',
        demonstrators: 'Demonstrators',
        laborants: 'Laboratory technicians',
        associates: 'Associates',
        userAccounts: 'User accounts',
        academicStaffList: 'List of academic staff',
        organizationalUnit: 'Organizational unit',
        selectOrganizationalUnit: 'Select organizational unit',
    },
    scholarship: {
        scholarship: 'Scholarships',
        scholarshipCode: 'Scholarship code',
    },
    poll: {
        index: 'No.',
        poll: 'Poll',
        polls: 'Polls',
        access: 'Access',
        accessProhibited: 'prohibited',
        accessGranted: 'granted',
        ban: 'Ban',
        approve: 'Approve',
        results: 'Results',
        pollResults: 'Results',
        reviewResults: 'Review results',
        question: 'Pitanje',
        questions: 'Pitanja',
        active: 'Aktivne ankete',
        created: 'Kreirane ankete',
        archived: 'Arhivirane ankete',
        pollTitle: 'Poll title',
        title: 'Title',
        type: 'Type',
        startDateStudents: 'Start date for students',
        startDate: 'Start date',
        endDate: 'End date',
        pollDetails: 'Details',
        details: 'Details',
        edit: 'Edit',
        delete: 'Delete',
        overview: 'Poll list',
        createNewPoll: 'Create new poll',
        newPoll: 'Nova anketa',
        creatingPoll: 'Kreiranje ankete',
        pollType: 'Poll type',
        comment: 'Comment',
        placeholderPollName: 'Unesite naziv',
        placeholderType: 'Odaberite tip',
        placeholderDate: 'Unesite datum',
        placeholderComment: 'Unesite komentar..',
        placeholderAnswer: 'Unesite odgovor',
        placeholderQuestion: 'Unesite pitanje',
        placeholderOfferedAnswer: 'Unesite ponuđeni odgovor',
        createPollButton: 'Kreiraj anketu',
        cancel: 'Odustani',
        addQuestionButton: 'Dodaj pitanje',
        addAnswerButton: 'Dodaj odgovor',
        offeredAnswers: 'Ponuđeni odgovori',
        section: 'Section',
        placeholderAssistants: 'Odaberite asistente',
        placeholderProfessors: 'Odaberite profesore',
        numberOfStudentsOnCourse: 'Number of students on course',
        numberOfStudentsWhoDoneCourse: 'Number of students who graded the course',
        numberOfStudentsWhoDoneProfessor: 'Number of students who evaluated the professor',
        numberOfStudentsWhoDoneAssistant: 'Number of students who evaluated the assistant',
        coursesOnPoll: 'Courses',
        noCoursesMess: 'Your courses are not on this poll.',
        noPollMess: 'There are currently no polls created.',
        noStudentsMess: 'No students in the selected course.',
        lateImplementationMess: 'The implementation of the course was created after the start of the poll.',
        noCoursesAssigned: 'You are not assigned to courses this semester.',
        sp: 'Study program',
        noDataForExcelExport: 'There was an error. No data available for generating the Excel file.',
        errorWhileExcelExport: 'There was an error while generating the Excel file.',
        successfullExcelExport: 'Excel file successfully generated.',
        voluntaryParticipationNotice: '* Your participation in the poll is entirely voluntary, and your answers remain confidential and anonymous. Data collected through the poll will only be presented as statistical data. Your honest and objective answers may indicate good practices or point out potential shortcomings and difficulties in the implementation of teaching activities, and help improve their future quality.',
        selectStaffForCourse: 'Select the professors and assistants for the course ({courseName}):',
        assistantGradingOptionalNotice: '* Rating the assistant is not mandatory; however, if you do not select an assistant now, you will not be able to rate them later.',
        professorsLabel: 'Professor(s):',
        assistantsLabel: 'Assistant(s):',
        continueButton: 'Continue',
        noProfessorsAssigned: 'No professors are assigned to this course.',
        connectStudentToCourseError: 'An error occurred while connecting the student to the course.',
        connectStudentToDirectionError: 'An error occurred while connecting the student to the study program.',
        alreadyAnswered: 'You have already responded to this poll.',
        errorFetchingQuestions: 'An error occurred. Unable to display questions.',
        questionWithoutOptions: 'Question has no offered answers: {text}',
        answersSentSuccess: 'Answers were sent successfully.',
        errorSendingAnswers: 'An error occurred, your answers were not sent.',
        notAllAnswered: 'You have not answered all questions.',
        noQuestionsInPoll: 'The poll has no questions!',
        noQuestions: 'No questions',
        sendAnswersButton: 'Submit answers',
        status: 'Status',
        evaluated: 'evaluated',
        notEvaluated: 'not evaluated',
        evaluateButton: 'Evaluate',
        notEnrolledCurrentSemesterMessage: 'You are not enrolled in the current semester, so you cannot view courses or access the poll. Please contact the student service of your faculty/academy.',
    },
    sidebar: {
        home: 'Home',
        personalInfo: 'Personal info',
        study: 'Study',
        gradesOverview: 'Grades',
        coursesOverview: 'Study program overview',
        collision: 'Collision courses',
        optional: 'Optional courses',
        currentSemesterCourses: 'Current semester',
        exams: 'Exams',
        activeExams: 'Active exams',
        finalizedExams: 'Finalized exams',
        register: 'Exam register',
        registeredExams: 'Registered exams',
        documents: 'Documents',
        reports: 'Reports',
        comment: 'Comments and suggestions',
        contact: 'Contact information',
        courses: 'Courses',
        statistic: 'Statistic',
        announcements: 'Announcements',
        foreignStudents: 'Incoming mobility',
        searchForeignStudents: 'Search students',
        createForeignStudents: 'Create student',
        registrationLinks: 'Registration links',
        nonCycleProgram: 'Non-cycle program',
        nonCycleStudents: 'Search students',
        nonCyclePrograms: 'Non-cycle programs',
        nonCycleProgramLead: 'Program coordinator',
        createNonCycleStudent: 'Create student',
        grading: 'Grading',
        mentorships: 'Mentorships',
    },
    route: {
        home: 'Home',
        personalInfo: '/student-personal-information',
        collisionCourses: '/collision-courses',
        optionalCourses: '/optional-courses',
        currentSemesterCourses: '/current-semester-courses',
        gradesOverview: '/grades',
        coursesOverview: '/study-program-overview',
        passedExams: '/passed-exams',
        registerExams: '/register-exams',
        registeredExams: '/registerd-exams',
        requests: '/documents',
        reports: '/reports',
        comments: '/comments-and-suggestions',
        contact: '/contact-information',

        finalized: '/finalized-exams',
        studentGrades: '/finalized-exams/students-list',
        examStatistic: '/finalized-exams/statistic',
        active: '/active-exams',
        inputGrades: '/active-exams/input-grades',
        filterStudentsForProfessor: '/students',
        studentsInfoFromSearch: '/students/profile',
        studentGradesAndInfo: '/active-exams/input-grades/student-info',
        studentGradesAndInfoFromFinalised: '/finalised-exams/students/student-info',
        upcomingExams: '/upcoming-exams',
        statistic: '/statistic-for-professor',
        personalInf: '/personal-information',
        courses: '/courses-list',
        studentsInfo: '/courses-list/students/information',
        studentsInfoSS: '/nastavno-osoblje/predmeti/studenti/detalji',
        students: '/courses-list/students',
        courseStudents: '/courses-list/students',
        courseDetails: '/courses-list/details',
        courseStatistic: '/courses-list/statistic',
        registeredStudents: '/registered-students',
        academicStaff: '/academic-staff',

        polls: '/polls',
        pollCourses: '/polls/courses',
        pollResults: '/polls/courses/results',
        access: '/poll-access',
        accessCourses: '/poll-access/courses',
        accessStudents: '/poll-access/courses/students',
        faq: '/faq',
        mentorships: '/mentorships',


    },
    orgUnitDetailed: {
        orgUnits: 'Organizacione jedinice',
        parents: 'Roditelji',
        types: 'Tipovi',
        addOrgUnitType: 'Dodaj tip',
        staffPosition: 'Position',
        staff: 'Staff',
        addresses: 'Adrese',
        addressesDesc: 'Sve adrese ove organizacione jedinice',
        street: 'Ulica',
        place: 'Mjesto',
        contacts: 'Contacts',
        addContacts: 'Dodaj kontakt',
        contactValue: 'Value',
        contactDescription: 'Description',
        contactType: 'Type',
        name: 'Name',
        errors: {
            changeName: 'Greska pri promjeni imena organizacione jedinice',
            gettingHierarchy: 'Greska pri dobavljanju hijerarhije',
            gettingOrgUnitDetails: 'Greska pri dobavljanju organizacione jedinice',
            gettingContactType: 'Greska pri dobavljanju tipova kontakta',
            addingContact: 'Greska pri dodavanju kontakta',
            deletingContact: 'Greska pri brisanju kontakta',
            creatingOrgUnit: 'Greska pri kreiranju organizacione jedinice',
            gettingOrganizationalUnits: 'Greska pri dobavljanju organizacionih jedinica',
            addingParent: 'Greska pri dodavanju roditelja',
            gettingPositions: 'Greska pri dobavljanju pozicija',
            gettingEmployees: 'Greska pri dobavljanju zaposlenika',
            mustHaveType: 'Ne moze se dodati zaposlenik ako nema tip organizacione jedinice',
            addingStaff: 'Greska pri dodavanju staff',
            gettingOrgUnitTypes: 'Greska pri dobavljanju tipova',
            addingOrgUnitTypes: 'Greska pri dodavanju tipova'
        }
    },
    mentorships: {
        title: 'Mentorships and committees',
        overview: 'Overview of mentorships and committee memberships',
        role: 'Role',
        studentName: 'Student full name',
        studyProgram: 'Study program',
        organizationalUnit: 'Organizational unit',
        thesisTopic: 'Topic',
        thesisTopicEn: 'Topic in English',
        academicYear: 'Academic year',
        themeApprovalDate: 'Topic approval date',
        grade: 'Grade',
        successfullyDefended: 'successfully defended',
        notDefended: 'did not defend',
        didNotAttend: 'did not attend',
        defenseDate: 'Defense date',
        selectAcademicYear: 'Select academic year',
        selectRole: 'Select role',
        noData: 'No data.',
        downloadExcel: 'Download the list in Excel',
        excelFileName: 'Mentorships and committees',
        excelSheetName: 'Mentorships'
    },
    student: {
        exams: 'Exams',
        canceled: 'You successfully canceled exam application.',
        registered: 'You successfully registered exam.',
        summerSemester: 'Summer semester',
        winterSemester: 'Winter semester',
        studyProgramView: 'Study program overview',
        collision: 'Collision',
        availableCollision: 'Available collision courses',
        theRestEcts: 'The rest of ECTS: ',
        currentSemesterCourses: 'Current semester courses',
        currentCourses: 'Current optional courses',
        noCollisionMessage: 'No current collision courses for register.',
        noCoursesMessage: 'No current optional courses.',
        noCurrentSemesterMessage: 'You are not enrolled in the current semester, and for that reason you cannot see the courses. Contact the student service of the faculty/academy.',
        optionalCourses: 'Optional courses',
        selectOptionalCourse: 'Confirm choice',
        availableOptionalCourses: 'Available optional courses',
        noElectiveMessage: 'No current optional courses for register.',
        study: 'Grades',
        showGrades: 'Grades overview',
        noGradesMessage: 'No grades!',
        deleteContactToast: 'The contact has been successfully deleted!',
        editContactToast: 'The contact has been successfully edited',
        editContactErrToast: 'Error! The contact has not been deleted!',
        addContactToast: 'The contact has been successfully added.',
        basicInfo: 'Basic info',
        previousEducation: 'Previous education',
        consentInfo: 'I agree to share my contact details with the teaching staff of the University of Sarajevo.',
        currentStudy: 'Current study',
        examDate: 'Exam date',
        registeredExams: 'Registerd exams',
        currentRegisteredExams: 'Current registered exams',
        noRegisteredExamsMessage: 'No registered exams.',
        allRegisteredExams: 'All registered exams',
        noPreviousRegisteredExamsMessage: 'No previous registered exams.',
        cancelExam: 'Cancel exam',
        registerExam: 'Exam register',
        register: 'Register exam',
        noExamsForRegisterMessage: 'No exams for register.',
        addNewContact: 'Add new contact',
        noContactInfo: 'No contact information.',
        passedExamsNumber: 'Number of passed exams',
        noCurrentSemesterCourses: 'No current semester courses.',
        registeredStudentsList: 'Registered students',
        accountInfo: 'Account info',
        userRole: 'User roles',
        editStudentData: 'Edit student data',
        emailEditSuccess: 'Email successfully changed!',
        emailEditError: 'An error occurred! Email was not changed.',
        contactConsentGiven: 'You have successfully given consent to display your contact information.',
        contactConsentWithdrawn: 'You have successfully withdrawn consent to display your contact information.',
        currentlyEnrolled: 'Currently enrolled',
        unfinalizedGradesNoticeHeader: 'Grades highlighted in yellow have not yet been finalized.',
        unfinalizedGradesNoticeContent: 'These grades will not appear on the transcript of records until finalized by the professor. In case of an error, please contact the professor or the student service.',
        selectOptionalCoursesWarning: 'When selecting elective courses, you need to check and select all elective courses; otherwise the selection will not be successful.',
        graduateInternship: 'Graduate internship period',
        notEnrolled: 'not enrolled',
        semesterEnrollmentCount: '{semester} — attempt {count}'
    },
    studentDocuments: {
        documentType: 'Document type',
        status: 'Status',
        add: 'Add request',
        editRequest: 'Edit current request',
        docRequest: 'Current document requests',
        createRequest: 'Add new document request',
        requests: 'Documents',
        send: 'Send',
        certificateType: 'Document type',
        selectCertificateType: 'Select document type',
        certificateReason: 'Certificate reason',
        selectCertificateReason: 'Select certificate reason',
        selectLanguage: 'Select language',
        writeComment: 'Comment...',
        previousDocRequest: 'Previous document requests',
        CurrentRequestMessage: 'No current document requests.',
        PreviousRequestMessage: 'No previous document requests.',
        sentRequestToast: 'Request was successfully sent',
        errSentRequestToast: 'Error! Request is not sent.',
        errSentRequestDuplicateToast: 'A request for this document has already been created.',
        cancelRequestToast: 'Request canceled.',
        cancelPopup: 'This request will be canceled!',
        showPopup: 'Show previous requests.',
        errInputToast: 'You did not enter all fields!',
        nonCycleDocumentsInfoIntro: 'If the student is enrolled in a non-cycle program, the following options are available:',
        nonCycleDocumentsInfoBullet1: 'transcript of records and',
        nonCycleDocumentsInfoBullet3: 'certificate, provided that the program completion date and certificate number are recorded in the system.',
        nonCycleDocumentsInfoBullet4: 'certificate supplement, if it was specified during program creation that the program has a certificate supplement.'
    },
    professorInputGrades: {
        showStatistic: 'Show in a table',
        statisticNote: '*Statistics include only courses from the year the faculty transitioned to the eUNSA system.',
        addMoreStatistic: 'Select one or more semesters from previous academic years to compare statistics for this course.',
        compareStatistics: 'Compare with other years',
        showStatisticField: 'The data shown is for',
        importTemplateInfo: 'You can download an Excel template file with list of non-graded students clicking the button \'Download Excel file with non-graded students\' in the top-left corner.',
        downloadExcelWithoutGrades: 'Download Excel file with non-graded students',
        importInfo1: 'The selected file must contain the following four columns:',
        importInfo2: 'Grades must be from the allowed set.',
        importInfo3: 'If there are duplicate students (same index) in the excel file, the grade from the later row will be used.',
        orderNotImportant: 'The order of the columns is not important.',
        missingRequiredFields: 'Row {row}: One of the required fields is missing (index, first name, last name, grade).',
        studentNotFound: 'Row {row}: Student "{firstName} {lastName}" with index "{index}" was not found among ungraded students.',
        studentLockedOrDroppedOut: 'The student is locked/withdrawn. If you need to enter a grade for this course, please contact the student affairs office.',
        enterGrade: 'Enter grade',
        // invalidGrade: 'Row {row}: Grade "{grade}" is not valid.',
        importGrades: 'Import grades',
        uploadFile: 'Upload Excel file',
        invalidFormat: 'Invalid file format. Only .xlsx is allowed.',
        invalidGrade: 'Invalid grade for student {index} ({ime}) – grade must be one of the allowed values.',
        importSuccess: 'Grades successfully loaded.',
        noFileSelected: 'No file selected.',
        invalidFileStructure: 'File structure is incorrect. Required columns: index, full name, grade.',
        submitImportedGrades: 'Submit grades',
        importedGradesInfo: 'Imported grades will be shown in the table. After reviewing, click the button to submit grades.',
        clearImportedGrades: 'Clear imported grades',
        invalidRowsFound: 'Invalid grades found. Please review and try again.',
        noGrade: 'No grade',
        selectFile: 'Select file',
        uploadExcel: 'Upload Excel file with grades',
        importSubmit: 'Submit grades',
        importFailed: 'Error importing grades',
        importErrors: 'Error importing grades',
        grade2: 'Grade',
        toastGradeImportSuccess: 'Grades successfully imported.',
        toastGradeImportFailed: 'Error importing grades.',

        finalizeInfo: 'After exam finalization all students that remained in not graded list will get grade',
        finalizeInfo2: 'not graded / did not attend exam.',
        grade: 'Grade',
        groupGrading: 'Group grading',
        groupGradingInfo: 'For group grading check students from the list (you can click on a table row or checkbox in the first row) ' +
            'and then choose grade. When you click on the button ',
        groupGradingInfo2: 'Grade',
        groupGradingInfo3: ' all of the checked students will be graded with chosen grade.',
        individuallyGrading: 'Individually grading',
        infoView: 'Overview',
        info: 'Information',
        personalInfo: 'Personal info',
        semesters: 'Semester overview',
        currentSemester: 'Current semester',
        studyInfo: 'Current study information',
        finalizeCheck: 'Are you sure you want to finalize the exam?',
        endOfEmploymentDate: 'Date of end of employment',
        endOfEmployment: 'End of employment',
        endOfEmploymentButton: 'End employment',
        contact: 'Contact information',
        inputGrades: 'Input grades',
        selectCourse: 'Select course',
        selectExamTerms: 'Select exam term',
        examType: 'Exam type',
        attention: 'Attention',
        registration: 'Registration',
        passed: 'Passage',
        selectGrade: 'Grade',
        course: 'Course',
        confirm: 'Confirm',
        studentsWithoutGrades: 'Not graded students',
        studentsWithGrades: 'Graded students',
        studyYear: 'Study year',
        department: 'Department',
        studyProgram: 'Study program',
        studentStudyType: 'Study type',
        selectStudyType: 'Select student status',
        selectStudyProgram: 'Select study program',
        selectDate: 'Select exam date',
        graded: 'Graded',
        edit: 'Edit',
        confirmGrade: 'Confirm grade',
        cancelGrade: 'Cancel grade',
        filterData: 'Filter data.',
        showTable: 'Show graded students.',
        CurrentGradesMessage: 'No graded students.',
        CurrentGradesFilterMessage: 'Filters on! No students are graded.',
        PreviousGradesMessage: 'There are no students who are not graded',
        PreviousGradesFilterMessage: 'Filters on! No students are graded',
        PreviousNoGradesFilterMessage: 'Filters on! There are no students who are not graded',
        selectAcademicYear: 'Select academic year',
        selectAcademicYears: 'Select academic years',
        selectSemester: 'select semester',
        examDate: 'Exam term',
        examDateDate: 'Exam date and time',
        examFinalizationTime: 'Exam finalization date and time',
        examOnlyDate: 'Exam date',
        selectExamDate: 'Select exam term',
        showStudents: 'Show students',
        selectNewCourse: 'Selec',
        inputFirstName: 'Enter firstname',
        inputLastName: 'Enter lastname',
        FiltersOn: 'Filters on!',
        getFilter: 'Filter',
        finalize: 'FINALIZE    EXAM',
        toastFilter: 'Choose what you want to filter data for!',
        toastFilterFailed: 'Filter failed',
        toastFilanizedExam: 'The exam is finalized!',
        toastStudentGraded: 'The student has been successfully graded!',
        toastStudentsGraded: 'The students have been successfully graded!',
        toastStudentGradedFailed: 'Error! Student not graded.',
        toastStudentsGradedFailed: 'Error! Students not graded.',
        activeExamsList: 'Active (non-finalized) exams',
        NoDataMessage: 'No active exams.',
        numberOfStudents: 'Number of registered students',
        gradeStudents: 'Gradeing students',
        registeredStudents: 'Students',
        addToCalendar: 'Add to calendar',
        activeCourse: 'Active exams',
        finalizedCourse: 'Finalized exams',
        finalizedCourseList: 'Finalized exams',
        toastStudentGradeEdited: 'The grade has been successfully updated.',
        toastStudentGradeCancel: 'The grade has been successfully canceled.',
        toastStudentGradeEditFailed: 'Error! The grade has not been edited.',
        toastStudentGradeCancelFailed: 'Error! The grade has not been canceled.',
        startDate: 'Exams of:',
        endDate: 'Exams up to:',
        NofinalizedExamsMessage: 'No finalized exams.',
        endAndStartDate: 'You need to enter from which date you want to take exams!',
        toastFinalizedFailed: 'The exam is not finalized!',
        NoUpcomingExamsMessage: 'No upcoming exams.',
        upcomingExams: 'Upcoming exams',
        upcomingExamsList: 'Upcoming exams',
        toastFinalized: 'The exam was successfully finalized!',
        studentInfo: 'Student information',
        showStudentInfo: 'Show student information',
        backToStudentsList: 'Back to students list',
        gradesList: 'Grades',
        inputGradeDate: 'Exam entry date',
        positions: 'Positions',
        titles: 'Titles',
        inputCourseName: 'Enter course name',
        gradedStudentsNumber: 'Number of graded students',
        averageGrade: 'Average grade: ',
        noDataForAcademicYear: 'No data for the selected academic year.',
        noCourses: 'No courses.',
        noCoursesMessage: 'No courses for selected academic year.',
        noCoursesMessageSS: 'No courses.',
        noCoursesFilter: 'Filters on! No courses.',
        gradedStudents: 'Graded students',
        notGradedStudents: 'Not graded students',
        externalStudentGrades: 'Incoming mobility student grades',
        printGradesList: ' Graded students by index number',
        printStudentsList: ' Registered students',
        finalizationCancelDate: 'Finalization cancle date',
        averageGradeNew: 'Average grade',
        methodName: 'Grading method',
    },
    professorStatistics: {
        statistics: 'Statistic',
        numberOfStudents: 'Number of students per subject',
        averrageGrade: 'Average grade',
        NoDataMessage: 'No data for this academic year.',
        currentAcademicYear: 'Current academic year',
        studentsChart: 'Number of students per course',
        gradeChart: 'Average grade per course',
        graphicShow: 'Graphic',
        tableShow: 'Table',
        courseId: 'Ordinal number',
        selectAcademicYear: 'Select academic year',
        academicYearHeader: ' academic year',
        courseStatistic: 'Statistics of the course',
        statisticForCourse: 'Statistics of the course: ',
        noStudents: 'No students.',
        noCourses: 'No course info.',
        noStudentsFilter: 'Filters on! No students.',
        printRegisteredStudents: 'Print a list of registered students',
        printStudentGrades: 'Print a list of students with grades',
        notFinalRegisteredStudentsList: '*The list of registered students is not final, because the exam is still open for application. ',
        noRegisteredStudents: 'No students registered.',
        studyProgramCourse: 'at which course is taught',
        courseExamDate: 'Course name / exam type / exam date',
        numberOfStudentsOnCourse: 'Number of students on course - n',
        numberOfDistinctStudentGradedActivities: 'Number of distinct students graded activities - n₁',
        numberOfExamRegistrations: 'Number of exam registrations',
        numberOfDistinctStudentsWhoAccessedExam: 'Number of distinct students who accessed exam - n₂',
        numberOfStudentsWhoAccessedExam: 'Number of students who accessed exam',
        numberOfStudentsWhoPassed: 'Number of students who passed course - k',
        averagePassedStudentsOnCourse: 'Average passed - k/n',
        averagePassedDistinctStudentGradedActivities: 'Average passed - k/n₁',
        averagePassed: 'Average passed - k/n₂',
        five: '5 (five)',
        six: '6 (six)',
        seven: '7 (seven)',
        eight: '8 (eight)',
        nine: '9 (nine)',
        ten: '10 (ten)',
        nonp: 'not graded/did not attend exam',
        io: 'fulfilled obligations',
        nz: 'nije zadovoljio',
        z: 'passed',
        no: 'nije odbranio',
        uo: 'successfully defended',
        np: 'not passed',
        na: 'did not defend',
        courseName: 'Course name',

    },
    contact: {
        contact: 'Contact information',
        unsa: 'UNSA',

        selectCommentType: 'Select comment type',
        inputMail: 'Input e-mail address',
        inputTitle: 'Input title',
        text: 'Text...',
        text_: 'Text',
        title: 'Message title',
        email: 'Your e-mail address',
        comments: 'Comments and suggestions',
        form: 'Form',
        errorMess: 'Niste unijeli sva obavezna polja.',
        mailValidationError: 'Enter valid email.',
        success: 'Vaš komentar / prijedlog je uspješno poslan.',
        error: 'Došlo je od greške! Vaš komentar / prijedlog nije poslan.',
        commentType: 'Comment type',
    },
    faq: {
        title: 'Frequently Asked Questions',
        searchPlaceholder: 'Search questions...',
        noResultsMessage: 'If you did not find your question in the list below, you can contact us using the',
        commentsLink: 'comments and suggestions form.',
        showAnswer: 'Show answer',
    },
    statistics: {
        statistic: 'Statistic',
        selectFacultyAndAcademicYear: 'Odaberite fakultet i akademsku godinu',
        selectFacultyAcademicYearAndStudyCycle: 'Odaberite fakultet, akademsku godinu i studijski ciklus',
        selectFaculty: 'Odaberite fakultet',
        selectAcademicYear: 'Odaberite akademsku godinu',
        selectStudyCycle: 'Odaberite studijski ciklus',
        citizenship: 'Državljani',
        selectCitizenship: 'Odaberite državljanstvo studenata',
        headerNumberEnrolledStudents: 'Broj upisanih studenata u prvi semestar ',
        headerAcademicYear: ' akademske godine',
        tableShow: 'Tabelarni prikaz',
        graphicShow: 'Grafički prikaz',
        place: 'Mjesto',
        numberOfStudents: 'Broj studenata',
        headerNumberEnrolledStudentsPerStudyCycles: 'Broj upisanih studenata u prvi semestar po studijskom ciklusu ',
        studentsNumber: 'Ukupan broj studenata: ',
        headerNumberEnrolledStudentsPerStudyTypes: 'Broj upisanih studenata u prvi semestar prema statusu studiranja ',
        headerNumberEnrolledStudentsPerAcademicYearsAndCycles: 'Broj upisanih studenata po studijskim godinama i ciklusima ',
        studyYear: 'Godina studija',
        headerNumberGraduatedStudentsPerStudyCycles: 'Broj studenata koji su završili određeni studijski ciklus ',
        headerNumberGraduatedStudents: 'Broj studenata koji su završili',
        graduated: 'diplomanata',
        enrollledBiH: 'Upisanih BH državljana',
        enrolledOther: 'Upisanih stranih državljana',
        graduatedStudents: 'Diplomirani studenti',
        perCyclesForFaculty: 'Po ciklusima za fakultet',
        perCyclesForFacultyMF: 'Po ciklusima za fakultet (M/Ž)',
        perCyclesForUniversity: 'Po ciklusima za Univerzitet',
        enrolledPerFaculty: 'Upisani studenti po fakultetima',
        perCycles: 'Po ciklusima',
        perStudyType: 'Prema statusu studiranja',
        perCountries: 'Po državama',
        perStudyYearAndCycles: 'Po studijskim godinama i ciklusima',
        perMunicipality: 'Po BH općinama',
        enrolledForUniversity: 'Upisani studenti na Univerzitetu',


    },
    externalStudent: {
        filterStudents: 'Filter students',
        createStudent: 'Create student',
        externalStudents: 'Incoming mobility students',
        externalStudent: 'Incoming mobility student',
        addingExternalStudent: 'Adding incoming mobility student',
        students: 'Incoming mobility students',
        academicYear: 'Academic Year',
        selectAcademicYear: 'Select Academic Year',
        faculty: 'Faculty',
        selectFaculty: 'Select Faculty',
        country: 'Country',
        selectCountry: 'Select Country',
        fullName: 'Full Name',
        dateOfBirth: 'Date of Birth',
        fieldOfEducation: 'Field of Study',
        studyCycle: 'Study Cycle',
        sendingInstitution: 'Sending Institution',
        university: 'University',
        sendingInstitutionCountry: 'Sending Institution Country',
        erasmusCode: 'Erasmus Code',
        contactPerson: 'Contact Person',
        email: 'Email',
        enterEmail: 'Enter Email',
        phone: 'Phone',
        exchangeEnded: 'The student finished the exchange on {date}',
        exchangeEndsOn: 'The student exchange ends on {date}',
        exchangeEndedAlt: 'The student finished the exchange in the academic {academicYear} year',
        exchangeEndsOnSummer: 'The student exchange ends on the end of summer semester of academic {academicYear} year',
        exchangeEndsOnWinter: 'The student exchange ends on the end of winter semester of academic {academicYear} year',
        downloadExcel: 'Download Excel List',
        createExternalStudent: 'Create incoming mobility student',
        enterPersonalAndInstitutionData: 'Enter personal data of the incoming mobility student and their sending institution',
        enterPersonalAndInstitutionDataPublic: 'Enter your personal data and the data of your institution',
        confirm: 'Confirm',
        clear: 'Clear',
        loading: 'Loading...',
        personalData: 'Personal Data',
        cancel: 'Cancel',
        edit: 'Edit',
        firstName: 'First Name',
        enterFirstName: 'Enter First Name',
        lastName: 'Last Name',
        enterLastName: 'Enter Last Name',
        birthDate: 'Date of Birth',
        enterBirthDate: 'Enter Date of Birth',
        gender: 'Gender',
        selectGender: 'Select Gender',
        englishLevelCompetence: 'English Competence Level',
        selectEnglishLevelCompetence: 'Select English Level',
        esi: 'ESI - European Student Identifier',
        enterEsi: 'Enter European Student Identifier',
        exchangeData: 'Exchange Data',
        mobilityProgram: 'Mobility Program',
        selectMobilityProgram: 'Select Mobility Program',
        mobilityType: 'Mobility Type',
        selectMobilityType: 'Select Mobility Type',
        mobilityFormat: 'Mobility Format',
        selectMobilityFormat: 'Select Mobility Format',
        externalStudentSemester: 'Semestar',
        selectExternalStudentSemester: 'Odaberite semestar',
        dateFrom: 'Start Date',
        enterDateFrom: 'Enter Start Date',
        dateTo: 'End Date',
        enterDateTo: 'Enter End Date',
        selectStudyCycle: 'Select Study Cycle',
        selectFieldOfEducation: 'Select Field of Study',
        sendingInstitutionData: 'Sending Institution',
        institutionName: 'Institution Name',
        enterInstitutionName: 'Enter Institution Name',
        institutionFaculty: 'Faculty',
        enterInstitutionFaculty: 'Enter Faculty Name',
        institutionDepartment: 'Department',
        enterInstitutionDepartment: 'Enter Department Name',
        institutionErasmusCode: 'Erasmus Code',
        enterInstitutionErasmusCode: 'Enter Erasmus Code',
        institutionCountry: 'Country',
        selectInstitutionCountry: 'Select Country',
        institutionAddress: 'Address',
        enterInstitutionAddress: 'Enter Institution Address',
        contactPersonFirstName: 'Contact First Name',
        enterContactPersonFirstName: 'Enter Contact First Name',
        contactPersonLastName: 'Contact Last Name',
        enterContactPersonLastName: 'Enter Contact Last Name',
        contactPersonEmail: 'Contact Email',
        enterContactPersonEmail: 'Enter Contact Email',
        contactPersonPhone: 'Contact Phone',
        enterContactPersonPhone: 'Enter Contact Phone',
        studentProfile: 'Student Profile',
        basicInformation: 'Basic Information',
        faculties: 'Faculties',
        grades: 'Grades',
        back: 'Back',
        nameAndSurname: 'Name and Surname',
        ordinalNumber: 'No.',
        facultyName: 'Faculty Name',
        indexNumber: 'Index Number',
        enterIndexNumber: 'Enter Index Number',
        contactFirstName: 'Contact First Name',
        contactLastName: 'Contact Last Name',
        contactEmail: 'Contact Email',
        contactPhone: 'Contact Phone',
        mainOrganizationalUnit: 'Main Organizational Unit',
        add: 'Add',
        save: 'Save',
        delete: 'Delete',
        noFaculties: 'No faculties to display.',
        studyProgramOrActivityType: 'Study Program / Activity Type',
        studyProgram: 'Study Program',
        courseOrActivity: 'Course / Activity',
        course: 'Course',
        ects: 'ECTS',
        professor: 'Professor',
        attendanceType: 'Attendance Type',
        examDate: 'Exam Date',
        grade: 'Grade',
        selectGrade: 'Select Grade',
        otherActivityTypes: 'Other Activity Types',
        selectActivityType: 'Select Activity Type',
        selectStudyProgram: 'Select Study Program',
        enterActivityName: 'Enter Activity Name',
        selectCourse: 'Select Course',
        enterEcts: 'Enter ECTS',
        selectProfessor: 'Select Professor',
        selectAttendanceType: 'Select Attendance Type',
        enterExamDate: 'Enter Exam Date',
        noGrades: 'No grades to display',
        documents: 'Documents',
        birthCountry: 'Country of Birth',
        selectBirthCountry: 'Select Country',
        citizenshipCountry: 'Nationality',
        selectCitizenshipCountry: 'Select Nationality',
        birthPlaceName: 'Place of Birth',
        enterBirthPlaceName: 'Enter Place of Birth',
        jmbg: 'Personal ID or Passport Number',
        enterJmbg: 'Enter Personal ID or Passport Number',
        studyType: 'Study Type',
        selectStudyType: 'Select Study Type',
        programName: 'Program Name',
        enterProgramName: 'Enter Program Name',
        dropoutDate: 'Dropout Date',
        enterDropoutDate: 'Enter Dropout Date',
        lockedAt: 'Locked at',
        enterLockedAt: 'Locked at',
        unlockStudent: 'Unlock Student',
        expiresAt: 'Expires At',
        enterExpiresAt: 'Enter Registration Link Expiration Date',
        submit: 'Submit',
        isced: 'According to ISCED 2013',
        registrationLinks: 'Registration Links',
        registeredStudents: 'Registered Students',
        registeredStudentsUsingLink: 'Registered students using this link',
        noAccessToDocumentsTab: 'Pristup sekciji Dokumenti ima samo studentska služba glavne / matične organizacione jedinice.',
        registrationLinkNotFoundOrExpired: 'Registration link not found or expired.',
        successfullySubmittedData: 'Your data has been successfully submitted!',
        closeThisPageSafely: 'You can safely close this page.',
        completionDetails: 'Completion details',
        enterCompletionDetails: 'Enter Completion Details',
        graduationDate: 'Graduation Date',
        enterGraduationDate: 'Enter Graduation Date',
        certificateNumber: 'Certificate Number',
        enterCertificateNumber: 'Enter Certificate Number',
        filledByReceivingInstitution: 'This section was filled by the receiving institution.',
        validUntil: 'Valid Until',
        numberOfSignedUp: 'Number of signed up',
        mobilityProgramPeriod: 'Mobility / Program Period',
        organizationalUnit: 'Organizational Unit',
        loadAgain: 'Load again',
        createRegistrationLink: 'Create New Registration Link',
        registrationLinksForMobilityStudents: 'Registration Links for Mobility Students',
        copyRegistrationLink: 'Copy Registration Link',
        openRegistrationLink: 'Open Registration Link',
        editRegistrationLink: 'Edit Registration Link',
        deleteRegistrationLink: 'Delete Registration Link',
        signedUpStudents: 'Signed Up Students',
        cyclicalStudyProgram: 'Cyclical study programme',
        nonCyclicalStudyProgram: 'Non-cyclical study programme',
        mobilityTypeInfoCyclical: 'Mobility carried out within one or two academic semesters.',
        mobilityTypeInfoNonCyclical: 'Mobility carried out within a predefined start and end period (summer/winter schools, internships, research work).',
        programNameInfo: 'Name of the mobility programme (e.g. Erasmus+ Blended Intensive Program) or, if it is a cyclical study, the name of the study programme (e.g. Computer Science).',
        erasmusCodeInfo: 'Erasmus code of the student’s home institution. Please consult your home institution or faculty administration for this information.',
        studyCycleInfo: 'Study cycle in which the student is enrolled at the home institution.',
        courseEnrollment: 'Courses',
        registrationLinkExpiredExplanation: 'This registration link is no longer valid or has expired. Please contact the International Cooperation Office or the receiving organisational unit for further assistance.',
        activityTypes: 'Activity Types: ',
        studyPrograms: 'Study Programs: ',
        consentText: 'I agree that my personal data will be collected and processed for the purpose of mobility application processing, in accordance with applicable data protection regulations.',
        courseCodeAlt: 'Code',
        courseCode: 'Course Code',
        enterCourseCode: 'Enter Course Code',
        lectureNumberAlt: 'L',
        lectureNumber: 'Lecture Hours',
        enterLectureNumber: 'Enter Lecture Hours',
        exerciseNumberAlt: 'E',
        exerciseNumber: 'Exercise Hours',
        enterExerciseNumber: 'Enter Exercise Hours',
        otherNumberAlt: 'O',
        otherNumber: 'Other Hours',
        enterOtherNumber: 'Enter Other Hours',
        nonGradedWarning: 'Student is not graded for these courses: ',
        programLead: 'Program Lead',
        selectProgramLead: 'Select Program Lead',
        lectureAndExerciseNumber: 'Number of Lecture / Exercise / Other hours',
        documentsInfoCycleIntro: 'If the student is enrolled in a cycle study program, the following options are available:',
        documentsInfoCycleBullet1: 'transcript of records and',
        documentsInfoCycleBullet2: 'status certificate.',
        documentsInfoNonCycleIntro: 'If the student is enrolled in a non-cycle program, the following options are available:',
        documentsInfoNonCycleBullet1: 'transcript of records and',
        documentsInfoNonCycleBullet2: 'status certificate.',
        documentsInfoNonCycleBullet3: 'certificate, provided that the program completion date and certificate number are recorded in the system.',
        documentsInfoNonCycleBullet4: 'certificate supplement, if it was specified during program creation that the program has a certificate supplement.',
        //
        createNonCycleStudyProgramStudent: 'Create Non-Cycle Study Programme Student',
        enterPersonalAndNonCycleStudyProgramData: 'Enter personal data and non-cycle study programme data',
        nonCycleStudyProgramData: 'Non-Cycle Study Programme Data',
        nonCycleProgram: 'Non-Cycle Programme',
        selectNonCycleProgram: 'Select Non-Cycle Programme',
        nonCycleStudyProgramType: 'Non-Cycle Study Programme Type',
        selectNonCycleStudyProgramType: 'Select Non-Cycle Study Programme Type',
        mainFieldOfStudy: 'Main Field of Study',
        enterMainFieldOfStudy: 'Enter main field of study',
        programStructure: 'Programme Structure',
        enterProgramStructure: 'Enter programme structure',
        programDurationMonths: 'Programme Duration (months)',
        enterProgramDurationMonths: 'Enter programme duration in months',
        programDurationEcts: 'Programme Duration (ECTS)',
        enterProgramDurationEcts: 'Enter programme duration in ECTS',
        accessRequirements: 'Access Requirements',
        enterAccessRequirements: 'Enter access requirements',
        programAttendanceType: 'Programme Attendance Type',
        selectProgramAttendanceType: 'Select programme attendance type',
        competencies: 'Competencies',
        enterCompetencies: 'Enter competencies',
        learningOutcomes: 'Learning Outcomes',
        enterLearningOutcomes: 'Enter learning outcomes',
        professionalStatus: 'Professional Status',
        enterProfessionalStatus: 'Enter professional status',
        additionalInformation: 'Additional Information',
        additionalInformationEng: 'Additional information in English',
        enterAdditionalInformation: 'Enter additional information',
        enterAdditionalInformationEng: 'Enter additional information in English',
        sourcesOfAdditionalInformation: 'Sources of Additional Information',
        enterSourcesOfAdditionalInformation: 'Enter sources of additional information',
        nonCycleStudyProgram: 'Non-Cycle Study',
        nonCycleStudyProgramStudents: 'Non-Cycle Study Programme Students',
        selectOrganizationalUnit: 'Select Organisational Unit',
        jmbgAlt: 'JMBG',
        enterJmbgAlt: 'Enter JMBG',
        studyProgramLanguage: 'Language of Instruction',
        selectStudyProgramLanguage: 'Select language of instruction',
        programInformation: 'Programme Information',
        programStructureAndDuration: 'Programme Structure and Duration',
        completedProgramAndLearningOutcomes: 'Completed Programme and Learning Outcomes',
        programPurpose: 'Programme Purpose',
        connectExistingStudent: 'Link to Existing Student',
        findStudent: 'Find Student',
        student: 'Student',
        selectStudent: 'Select Student',
        selectTemplate: 'Select Template',
        template: 'Template',
        templateName: 'Template Name',
        enterTemplateName: 'Enter Template Name',
        saveTemplate: 'Save Template',
        scholarshipAmount: 'Scholarship Amount (EUR)',
        enterScholarshipAmount: 'Enter scholarship amount (EUR)',
        languages: 'Languages of Instruction',
        selectLanguages: 'Select languages of instruction',
        nonCyclePrograms: 'Non-Cycle Programmes',
        createNonCycleProgram: 'Create Non-Cycle Programme',
        editNonCycleProgram: 'Edit Non-Cycle Programme',
        deleteNonCycleProgram: 'Delete Non-Cycle Programme',
        programNameEn: 'Programme Name (English)',
        enterProgramNameEn: 'Enter programme name in English',
        mainFieldOfStudyEn: 'Main Field of Study (English)',
        enterMainFieldOfStudyEn: 'Enter main field of study in English',
        programStructureEn: 'Programme Structure (English)',
        enterProgramStructureEn: 'Enter programme structure in English',
        accessRequirementsEn: 'Access Requirements (English)',
        enterAccessRequirementsEn: 'Enter access requirements in English',
        learningOutcomesEn: 'Learning Outcomes (English)',
        enterLearningOutcomesEn: 'Enter learning outcomes in English',
        professionalStatusEn: 'Professional Status (English)',
        enterProfessionalStatusEn: 'Enter professional status in English',
        additionalInformationEn: 'Additional Information (English)',
        enterAdditionalInformationEn: 'Enter additional information in English',
        sourcesOfAdditionalInformationEn: 'Sources of Additional Information (English)',
        enterSourcesOfAdditionalInformationEn: 'Enter sources of additional information in English',
        nonCycleProgramStudents: 'Students on Non-Cycle Programme',
        groupGraduating: 'Group Graduating',
        confirmGroupGraduation: 'Confirm',
        cancelGroupGraduation: 'Cancel',
        gradesInfo: 'This tab displays all students who have enrolled in the course within the framework of cyclical mobility (e.g., through Erasmus+, CEEPUS, or other similar international mobility programs).\n' +
            '\n' +
            'For these students, it is possible to adjust the grade date if the grade is entered on a date that differs from the officially scheduled examination period. This option is available exclusively for students participating in mobility programs.',
        includeGraded: 'Include graded',
        comment: 'Comment',
        enterComment: 'Enter comment',
        programHasCertificateSupplement: 'Upon completion of the program a Certificate Supplement is awarded, which contains detailed information about the program, achieved learning outcomes and competencies.',
        programHasCertificateSupplementShort: 'Programme has Certificate Supplement',
        programEnrolmentYear: 'Programme enrolment year',
        toast: {
            requireFacultyOrDepartment: 'At least one of Faculty or Department is required.',
            startDateBeforeEndDate: 'Start date must be before end date.',
            createError: 'Error while creating student.',
            createSuccess: 'Student created successfully. Please add the corresponding faculties now.',
            requireFaculty: 'Faculty entry is required.',
            duplicateOrganizationalUnit: 'Cannot add the same organizational unit more than once!',
            singleMainOrganizationalUnit: 'Only one organizational unit can be the main one.',
            facultyAdded: 'Faculty successfully added.',
            facultyDeleted: 'Faculty successfully deleted.',
            facultyUpdated: 'Faculty successfully updated.',
            facultyDeleteErrorLinked: 'Cannot delete faculty while the student is enrolled in courses at this faculty!',
            facultyDeleteError: 'Error while deleting faculty!',
            saveError: 'Error while saving data!',
            fillRequiredFields: 'All required fields must be filled.',
            duplicateCourse: 'Cannot add the same course more than once!',
            courseAdded: 'Course successfully added.',
            courseDeleted: 'Course successfully deleted.',
            courseUpdated: 'Course successfully updated.',
            editSuccess: 'Student successfully edited!',
            editError: 'Error while editing student.',
            errorWhileSubmittingData: 'Error while submitting your data.',
            errorFetchingData: 'Error while fetching data.',
            registrationLinkDeleted: 'Registration link successfully deleted.',
            registrationLinkCreated: 'Registration link successfully created.',
            registrationLinkEdited: 'Registration link successfully edited.',
            registrationLinkCopied: 'Registration link successfully copied to clipboard.',
            nonCycleProgramCreated: 'Non-Cycle Programme successfully created.',
            nonCycleProgramEdited: 'Non-Cycle Programme successfully updated.',
            nonCycleProgramDeleted: 'Non-Cycle Programme successfully deleted.',
            studentSuccessfullyDeleted: 'Student successfully deleted.',
            unlockSuccess: 'Student successfully unlocked.',
            unlockError: 'Error while unlocking student.',
            //
            firstAndLastNameRequired: 'First and last name are required.',
            templateSaveSuccess: 'Template successfully saved.',
            templateSaveError: 'Error while saving template.',
            groupGraduationSuccess: 'Graduation dates saved successfully.',
        }
    },
    semesterManagement: {
        toast: {
            fillRequiredFields: 'All required fields must be filled.',
            startDateBeforeEndDate: 'Start date must be before end date.',
            semesterEdited: 'Semester successfully edited.',
            semesterCreated: 'Semester successfully created.',
            saveError: 'Error while saving data!',
        },
        confirm: 'Confirm',
        cancel: 'Cancel',
        academicYear: 'Academic Year',
        selectAcademicYear: 'Select academic year',
        semesterType: 'Semester type',
        semesterTypeSelect: 'Select semester type',
        semesterStartDate: 'Semester start date',
        semesterEndDate: 'Semester end date',
        startDateOfEarlyEnrollment: 'Start date of early enrollment'
    },
    assets: {
        common: {
            orgUnit: 'Organizational unit',
            send: 'Send',
            edit: 'Edit',
            cancel: 'Cancel',
            filtersOn: 'Filter enabled',
            filter: 'Filter data',
            noData: 'No data',
        },
        vehicles: {
            title: 'Vehicles',
            add: 'Add new vehicle',
            edit: 'Edit vehicle',
            about: 'About vehicle',
            manufacturer: 'Manufacturer',
            model: 'Model',
            type: 'Type',
            vehicleSpecification: 'Vehicle specifications',
            licencePlate: 'License plate',
            chassisNumber: 'Chassis number',
            numberOfSeats: 'Number of seats',
            productionYear: 'Production year',
            purchaseYear: 'Purchase year',
            status: 'Status',
            fuelType: 'Fuel type',
            listOfVehicles: 'List of vehicles',
            deleteError: 'Error while deleting vehicle!',
            deleteConstraintError: 'Cannot delete vehicle because it is used in other records!',
        },
        organizationalUnitProperties: {
            deleteError: 'Error while deleting property!',
            deleteConstraintError: 'Cannot delete property because it is used in other records!',
        },
        equipment: {},
        leases: {
            deleteError: 'Error while deleting lease!',
            deleteConstraintError: 'Cannot delete lease because it is used in other records!',
        },
        leaseholders: {
            addressDeleted: 'Successfully deleted address!',
            addressDeleteError: 'An error occurred while deleting the address!',
            contactDeleted: 'Successfully deleted contact!',
            contactDeleteError: 'An error occurred while deleting the contact!',
            deleteError: 'Error while deleting leaseholder!',
            deleteConstraintError: 'Cannot delete leaseholder because there are linked leases!',
            addressDeleteConstraintError: 'Cannot delete address because it is used in other records!',
            contactDeleteConstraintError: 'Cannot delete contact because it is used in other records!',
        },
        rooms: {
            deleteError: 'Error while deleting!',
            roomOrgUnitPropertyDeleteConstraintError: 'Cannot delete item because it is used in other records!',
        },
    },
    announcements: {
        announcements: 'Announcements',
        noAnnouncements: 'No announcements to display.',
        showContent: 'Show content',
        hideContent: 'Hide content',
        searchPlaceholder: 'Search announcements...',
        roleAdministrator: 'Administrator',
        roleAida: 'AIDA',
        roleInternationalCooperationOffice: 'International Cooperation Office',
    }
};



// WEBPACK FOOTER //
// ./src/messages/messages_en.js